/** RouteOne's own markup, e.g. the Streamline button: `$$SS_F000BA_CS=1~...~FS=14$$`. */
const ROUTE_ONE_DIRECTIVE = /\$\$[\s\S]*?\$\$/g;

/**
 * Ally packs a whole decision into one string, so the pipe is its real separator. `<br>` and a
 * literal `\n` -- the two characters, not a newline; the escape survives RouteOne's transport --
 * are how an underwriter's free text arrives already broken into bullets, so they separate too.
 * A genuine newline stays whitespace: that is a wrapped sentence, not a new line to read.
 */
const SEGMENT_SEPARATORS = /\||<br\s*\/?>|(?:\\r)?\\n/gi;

/** Leftover markup from the decisions that arrive as HTML rather than plain text. */
const HTML_TAG = /<[^>]*>/g;

/** Ally wraps its stipulations in runs of asterisks: `**Book Out Sheet Required**`. */
const WRAPPING_EMPHASIS = /^[*\s]+|[*\s]+$/g;

/**
 * Ally's note about its own ADS grid. The modal shows the grid, the paragraph is on nearly every
 * gridded decision, and it crowds out the stipulations that are specific to this deal.
 */
const ADS_GRID_NOTE = /^line 3 amf change for the alternatives provided on the grid/i;

/** A segment that is only the lender's name tells the dealer nothing they cannot already see. */
const LENDER_NAME_ONLY = /^ally(\s+(bank|financial))?$/i;

/** Whether anything survived the strip -- a lone bullet or dash left by a split has not. */
const hasContent = (segment: string) => /[a-z0-9]/i.test(segment);

/** The decision comments worth showing, one line each. Empty when there is nothing to read. */
export const cleanDecisionComments = (comments?: string[] | null): string[] => {
  const segments = (comments ?? [])
    .flatMap((comment) => (comment ?? '').replace(ROUTE_ONE_DIRECTIVE, ' ').split(SEGMENT_SEPARATORS))
    .map((segment) => (segment ?? '').replace(HTML_TAG, ' ').replace(/\s+/g, ' ').replace(WRAPPING_EMPHASIS, ''))
    .filter((segment) => hasContent(segment) && !ADS_GRID_NOTE.test(segment) && !LENDER_NAME_ONLY.test(segment));

  return Array.from(new Set(segments));
};
